import 'reflect-metadata';
import { ColumnOptions } from '../models';

export function Column(options: ColumnOptions) {
  return function (target: any, propertyKey: string) {
    Reflect.defineMetadata('columnOptions', options, target, propertyKey);
  };
}
